import {
  Grid,
  Tooltip,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,
  CircularProgress,
} from '@mui/material'
import React, { useState, useEffect } from 'react'
import { deleteCategory, getCategories, updateLastActive } from '../../utils/templatesApi'
import DeleteIcon from '@mui/icons-material/Delete'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import EditIcon from '@mui/icons-material/Edit'
import TablePagination from '@mui/material/TablePagination'

const CategoriesList = ({ refresh, handleOpen ,userId}) => {
  const [list, setList] = useState([])
  const [rowsPerPage, setRowsPerPage] = React.useState(10)
  const [totalCount, setTotalCount] = useState(0)
  const [page, setPage] = React.useState(0)
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  const handleChangePage = (event, newPage) => setPage(newPage)

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  const getList = async () => {
    const limit = rowsPerPage
    try {
      setLoading(true)
      const response = await getCategories(page, limit)
      setList(response.data)
      setLoading(false)
      setTotalCount(response.meta.totalItems)
    } catch (error) {
      console.log('error: ', error)
      toast.error('failed to load categories')
      setLoading(false)
    }
  }
  useEffect(() => {
    getList()
  }, [page, rowsPerPage, refresh])

  const handleDelete = async id => {
    try {
      setLoading(true)
      updateLastActive(userId, new Date())
      const response = await deleteCategory(id)
      if (response.success) {
        if (list.length === 1 && page > 0) {
          setPage(prev => prev - 1) // Move to previous page
        } else {
          getList()
        }
        toast.success('Category Deleted Successfully')
      }
      setLoading(false)
    } catch (error) {
      console.error('Error deleting category:', error)
      toast.error('Failed to delete category')
      setLoading(false)
    }
  }

  const handleEdit = id => {
    navigate(`/${id}`)
    handleOpen()
    updateLastActive(userId, new Date())
  }
  return (
    <>
      {loading ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '70vh',
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <>
          <TableContainer sx={{ mt: 2, minWidth: '80vw', maxHeight: ' 70vh' }}>
            <Table aria-label='customized table'>
              <TableHead>
                <TableRow
                  sx={{
                    backgroundColor: '#111827',
                    position: 'sticky',
                    top: 0,
                  }}
                >
                  <TableCell sx={{ color: 'white' }}>Category Name</TableCell>

                  <TableCell sx={{ color: 'white', textAlign: 'right' }}>
                    Actions
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {list?.length > 0 ? (
                  list?.map(category => (
                    <TableRow key={category.id}>
                      <TableCell>{category.category_name}</TableCell>

                      <TableCell sx={{ cursor: 'pointer' }}>
                        <Grid
                          sx={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            gap: 1,
                          }}
                        >
                          <Tooltip title='Edit'>
                            <Grid onClick={() => handleEdit(category.id)}>
                              <EditIcon
                                sx={{ cursor: 'pointer', color: '#1976d2' }}
                              />
                            </Grid>
                          </Tooltip>
                          <Tooltip title='Delete'>
                            <Grid onClick={() => handleDelete(category.id)}>
                              <DeleteIcon
                                sx={{ cursor: 'pointer', color: '#e53935' }}
                              />
                            </Grid>
                          </Tooltip>
                        </Grid>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={2} align='center'>
                      No categories found.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component='div'
            count={totalCount}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </>
      )}
    </>
  )
}

export default CategoriesList
